import { ConfirmationDialog } from '@dittolive/anvil'
import React from 'react'

import CreateOrUpdateWebhookForm, {
  CREATE_OR_UPDATE_WEBHOOK_FORM_ID,
} from './CreateOrUpdateWebhookForm'

type Props = {
  /** Whether the modal is visible. */
  show: boolean
  /** Callback to close the modal. */
  onCancel: () => void
  /** Callback to confirm the creation of the webhook. */
  onConfirm: (name: string, url: string, legacy: boolean) => void
  /** Current list of other webhooks, to avoid duplicated names being created. */
  existingWebhookNames: string[]
  /** Whether DQL auth webhook feature is enabled (shows legacy toggle) */
  enableDqlAuthWebhook?: boolean
}

export default function CreateProviderModal({
  show,
  onCancel,
  onConfirm,
  existingWebhookNames,
  enableDqlAuthWebhook,
}: Props) {
  return (
    <ConfirmationDialog
      size="md"
      open={show}
      onCancel={onCancel}
      confirmButtonText="Add webhook"
      cancelButtonText="Cancel"
      confirmationButtonForm={CREATE_OR_UPDATE_WEBHOOK_FORM_ID}
      data-testid="creationWebhookModal"
      title="New auth webhook"
      description="Give your webhook a memorable name and add your webhook URL."
    >
      <CreateOrUpdateWebhookForm
        existingWebhookNames={existingWebhookNames}
        onSubmit={onConfirm}
        enableDqlAuthWebhook={enableDqlAuthWebhook}
      />
    </ConfirmationDialog>
  )
}
